module.exports = __webpack_public_path__ + "img/szzyk-img.afce9462.png";